import { render } from "./AdminRiderDetailList.vue?vue&type=template&id=90325cba&scoped=true&ts=true&lang=true"
import script from "./AdminRiderDetailList.vue?vue&type=script&lang=ts"
export * from "./AdminRiderDetailList.vue?vue&type=script&lang=ts"

import "./AdminRiderDetailList.vue?vue&type=style&index=0&id=90325cba&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90325cba"]])

export default __exports__